import React from 'react'
import { Chart, type ReactGoogleChartProps } from 'react-google-charts'
import { isValidGoogleChartsMatrixData } from '../../utils/isValidGoogleChartsMatrixData'

export interface GoogleChartOrEmptyProps {
  chartType: ReactGoogleChartProps['chartType']
  data: unknown
  options?: ReactGoogleChartProps['options']
  width?: ReactGoogleChartProps['width']
  height?: ReactGoogleChartProps['height']
  emptyLabel?: string
}

function heightToCss(height: string | number | undefined): string | number {
  if (height === undefined) {
    return 300
  }
  return height
}

const emptyShellStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#64748b',
  fontSize: 14,
  background: 'transparent',
  borderRadius: 8,
  width: '100%'
}

/**
 * Renders react-google-charts Chart when `data` is a valid matrix; otherwise a muted "No data" area.
 */
const GoogleChartOrEmpty: React.FC<GoogleChartOrEmptyProps> = ({
  chartType,
  data,
  options,
  width = '100%',
  height = '300px',
  emptyLabel = 'No data'
}) => {
  if (!isValidGoogleChartsMatrixData(data)) {
    return (
      <div
        role="status"
        aria-label="No chart data"
        style={{
          ...emptyShellStyle,
          height: heightToCss(height)
        }}
      >
        {emptyLabel}
      </div>
    )
  }

  return (
    <Chart
      chartType={chartType}
      width={width}
      height={height}
      data={data as ReactGoogleChartProps['data']}
      options={options}
    />
  )
}

export default GoogleChartOrEmpty
